import {TranslationFunction} from "../../i18n/i18n";
import {CatalogFormatter} from "../../common/catalog/CatalogFormatter";
import {IdentitySource} from "../../client/user/User";

export class UserIdentitySourceFormatter {

    static formatIdentitySource(identitySource: IdentitySource | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(identitySource, "userIdentitySource", t);
    }
}
